import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function ScorePage() {
  const apiData = useSelector((state) => state.questionResult.apiData);
  const result = useSelector((state) => state.result);
  const Listen_Que_Data = JSON.parse(localStorage.getItem("Listen_Que")) || [];
  const Read_Que_Data = JSON.parse(localStorage.getItem("Read_Que")) || [];
  const Speek_Que_Data = JSON.parse(localStorage.getItem("Speek_Que")) || [];
  const Write_Que_Data = JSON.parse(localStorage.getItem("Write_Que")) || [];

  const Listen_Que_Answer = Listen_Que_Data.filter(ele => ele.answer?.trim().toLowerCase() === ele.selectedOption?.trim().toLowerCase())
  const Read_Que_Answer = Read_Que_Data.filter(ele => ele.answer?.trim().toLowerCase() === ele.selectedOption?.trim().toLowerCase())
  const Speek_Que_Answer = Speek_Que_Data.filter(ele => ele.answer?.trim().toLowerCase() === ele.selectedOption?.trim().toLowerCase())
  const Write_Que_Answer = Write_Que_Data.filter(ele => ele.answer?.trim().toLowerCase() === ele.selectedOption?.trim().toLowerCase())


  const totalQues = apiData?.data?.Listen_Que?.Total + apiData?.data?.Speek_Que?.Total + apiData?.data?.Read_Que?.Total + apiData?.data?.write_Que?.Total;
  const totalAns = Listen_Que_Answer?.length + Speek_Que_Answer?.length + Read_Que_Answer?.length + Write_Que_Answer?.length;
  const totalAttemptQues = Listen_Que_Data?.length + Read_Que_Data?.length + Speek_Que_Data?.length + Write_Que_Data?.length;

  const listenQuesCount = apiData?.data?.Listen_Que?.Total;
  const speekQuesCount = apiData?.data?.Speek_Que?.Total;
  const readQuesCount = apiData?.data?.Read_Que?.Total;
  const writeQuesCount = apiData?.data?.write_Que?.Total;


  function calculatePercentage(obtained, total) {
    if (total === 0) return 0;
    return ((obtained / total) * 100).toFixed(2);
  }
  // -------- pdf genrate --------
  const handleDownloadPDF = () => {
    const doc = new jsPDF('p', 'pt', 'a4'); // portrait, points, A4
    let startY = 40; // top margin

    // ---------- PDF Header ----------
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text("Candidate Final Score Report", doc.internal.pageSize.getWidth() / 2, startY, { align: "center" });
    startY += 30;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Student Name: ${result.name}`, 40, startY);
    startY += 18;
    doc.text(`Class: ${result.class}`, 40, startY);
    startY += 18;
    doc.text(`School: ${result.school}`, 40, startY);
    startY += 25;

    // ---------- Section-wise Questions ----------
    const tableColumn = ["Question", "Correct Answer", "Your Answer", "Status"];
    const generateTableRows = (data) => {
      return data.map((item) => {
        const status =
          item.answer?.trim().toLowerCase() === item.selectedOption?.trim().toLowerCase()
            ? "Correct"
            : "Incorrect";
        return [
          item.Quetion || "",
          item.answer || "",
          item.selectedOption || "",
          status
        ];
      });
    };

    const sections = [
      { title: "Listening Section", data: Listen_Que_Data },
      { title: "Reading Section", data: Read_Que_Data },
      { title: "Speaking Section", data: Speek_Que_Data },
      { title: "Writing Section", data: Write_Que_Data }
    ];

    sections.forEach((section) => {
      if (section.data.length > 0) {
        // Section title
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 51, 102); // dark blue
        doc.text(section.title, 40, startY);
        startY += 5;

        autoTable(doc, {
          startY: startY,
          head: [tableColumn],
          body: generateTableRows(section.data),
          theme: 'grid',
          headStyles: { fillColor: [0, 102, 204], textColor: 255, fontStyle: 'bold' },
          alternateRowStyles: { fillColor: [240, 240, 240] },
          margin: { left: 40, right: 40 },
          styles: { fontSize: 10, cellPadding: 4 },
        });

        startY = doc.lastAutoTable.finalY + 20;
      }
    });

    // ---------- Final Summary Table ----------
    const summaryColumn = ["Topic", "Final Obtained", "Attempted Questions", "Average (%)"];
    const summaryData = [
      [
        "LISTENING TEST",
        `${listenQuesCount}/${Listen_Que_Answer?.length}`,
        Listen_Que_Data?.length,
        `${calculatePercentage(Listen_Que_Answer?.length, listenQuesCount)}%`
      ],
      [
        "SPEAKING TEST",
        `${speekQuesCount}/${Speek_Que_Answer?.length}`,
        Speek_Que_Data?.length,
        `${calculatePercentage(Speek_Que_Answer?.length, speekQuesCount)}%`
      ],
      [
        "READING TEST",
        `${readQuesCount}/${Read_Que_Answer?.length}`,
        Read_Que_Data?.length,
        `${calculatePercentage(Read_Que_Answer?.length, readQuesCount)}%`
      ],
      [
        "WRITING TEST",
        `${writeQuesCount}/${Write_Que_Answer?.length}`,
        Write_Que_Data?.length,
        `${calculatePercentage(Write_Que_Answer?.length, writeQuesCount)}%`
      ],
      [
        "TOTALS",
        `${totalQues}/${totalAns}`,
        `${totalAttemptQues}`,
        `${calculatePercentage(totalAns, totalQues)}%`
      ]
    ];

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 51, 102);
    doc.text("Final Results Summary", 40, startY);
    startY += 5;

    autoTable(doc, {
      startY: startY,
      head: [summaryColumn],
      body: summaryData,
      theme: 'grid',
      headStyles: { fillColor: [0, 102, 204], textColor: 255, fontStyle: 'bold' },
      bodyStyles: { fontSize: 11 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 120 },
        1: { cellWidth: 80 },
        2: { cellWidth: 80 },
        3: { cellWidth: 80 },
      },
      margin: { left: 40, right: 40 },
    });

    doc.save("Final_Score_Report.pdf");
  };

  return (
    <>
      {/* ---------- download pdf ----------*/}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-end",
          alignItems: "flex-start",
        }}
      >

        <Button
          variant="contained"
          color="primary"
          onClick={handleDownloadPDF}
        >
          Score Download
        </Button>
      </Stack>
      {/* <PdfGenrateFinalScore /> */}
      {/* ---------- Results Section ----------*/}
      <Box sx={{ p: 4, maxWidth: 800, margin: "auto", backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
        <Box sx={{ marginBottom: 3 }}>
          <Typography variant="h6" fontWeight="bold">
            Student Name: {result.name}
          </Typography>
          <Typography>Class: {result.class}</Typography>
          <Typography>School: {result.school}</Typography>
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}> TOTAL MARKS: {result.totalMarks}</TableCell> */}
                <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Topic</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Final Obtained</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Attempted Questions</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Average  (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "12px" }}><img src={`/images/${1}.jpeg`} alt="Next" style={{ width: '30px', height: 'auto' }} /></span>
                    <Typography>LISTENING TEST</Typography>
                  </Box>
                </TableCell>
                <TableCell>{listenQuesCount}/{Listen_Que_Answer?.length}</TableCell>
                <TableCell>{Listen_Que_Data?.length}</TableCell>
                <TableCell>{calculatePercentage(Number(Listen_Que_Answer?.length), Number(listenQuesCount))}%</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "12px" }}><img src={`/images/${2}.jpeg`} alt="Next" style={{ width: '30px', height: 'auto' }} /></span>
                    <Typography>SPEAKING TEST</Typography>
                  </Box>
                </TableCell>
                <TableCell>{speekQuesCount}/{Speek_Que_Answer?.length}</TableCell>
                <TableCell>{Speek_Que_Data?.length}</TableCell>
                <TableCell>{calculatePercentage(Number(Speek_Que_Answer?.length), Number(speekQuesCount))}%</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "12px" }}><img src={`/images/${3}.jpeg`} alt="Next" style={{ width: '30px', height: 'auto' }} /></span>
                    <Typography>READING TEST</Typography>
                  </Box>
                </TableCell>
                <TableCell>{readQuesCount}/{Read_Que_Answer?.length}</TableCell>
                <TableCell>{Read_Que_Data?.length}</TableCell>
                <TableCell>{calculatePercentage(Number(Read_Que_Answer?.length), Number(readQuesCount))}%</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "12px" }}><img src={`/images/${4}.jpeg`} alt="Next" style={{ width: '30px', height: 'auto' }} /></span>
                    <Typography>WRITING TEST</Typography>
                  </Box>
                </TableCell>
                <TableCell>{writeQuesCount}/{Write_Que_Answer?.length}</TableCell>
                <TableCell>{Write_Que_Data?.length}</TableCell>
                <TableCell>{calculatePercentage(Number(Write_Que_Answer?.length), Number(writeQuesCount))}%</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography>TOTALS</Typography>
                  </Box>
                </TableCell>
                <TableCell>{totalQues}/{totalAns}
                </TableCell>
                <TableCell>{totalAttemptQues} </TableCell>
                <TableCell>{calculatePercentage(Number(totalAns), Number(totalQues))}%</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}

export default ScorePage;